module.exports = __webpack_public_path__ + "static/tv-backlight-07314a21f3cb1d240c49fa7cb945c617.png";